import { render, staticRenderFns } from "./CartEmpty.vue?vue&type=template&id=246c527c&scoped=true"
import script from "./CartEmpty.vue?vue&type=script&lang=js"
export * from "./CartEmpty.vue?vue&type=script&lang=js"
import style0 from "./CartEmpty.vue?vue&type=style&index=0&id=246c527c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246c527c",
  null
  
)

export default component.exports